import React from 'react';
import { cx } from './cx';

export interface AdminModCardProps {
  avatar?: React.ReactNode;
  name: React.ReactNode;
  /** thời gian / dòng phụ 12px */
  meta?: React.ReactNode;
  /** góc phải đầu thẻ: nhãn trạng thái, menu … */
  headExtra?: React.ReactNode;
  /** ảnh/video bài, đặt trong khung bo 12px */
  media?: React.ReactNode;
  /** nút 32px canh phải ở chân thẻ; nút duyệt (success) đứng cuối */
  actions?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

// Thẻ bài trong màn kiểm duyệt; đặt nhiều thẻ trong <div className="adm-mod-grid">.
export const AdminModCard = ({ avatar, name, meta, headExtra, media, actions, className, children }: AdminModCardProps) => (
  <article className={cx('adm-mod-card', className)}>
    <div className="adm-mod-card__head">
      {avatar ?? <span className="adm-mod-card__avatar" aria-hidden="true" />}
      <div className="adm-mod-card__who">
        <div className="adm-mod-card__name">{name}</div>
        {meta && <div className="adm-mod-card__meta">{meta}</div>}
      </div>
      {headExtra}
    </div>
    {children && <div className="adm-mod-card__body">{children}</div>}
    {media && <div className="adm-mod-card__media">{media}</div>}
    {actions && <div className="adm-mod-card__actions">{actions}</div>}
  </article>
);

export default AdminModCard;
